import React, { useEffect } from "react";
// import { Box, Container, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import HeroSection from "../../components/lp/challenges/hero";
import ChallengesSection from "../../components/lp/challenges";
import FeaturesSection from "../../components/lp/challenges/feature";
import ComparisonTable from "../../components/lp/challenges/comparisonTable";
import SystemArchitecture from "../../components/lp/challenges/systemArchitecture";
import ComponentsList from "../../components/lp/challenges/componentsList";
import CaseStudies from "../../components/lp/challenges/caseStudies";
import UsageFlow from "../../components/lp/challenges/usageFlow";
import TeamSection from "../../components/lp/challenges/teamSection";
import Pricing from "../../components/lp/challenges/pricing";
import Faq from "../../components/lp/challenges/faq";
import ContactSection from "../../components/lp/challenges/contactSection";
import Navbarlp from "../../common/LPHeader";
import FooterLP from "../../common/LPFooter";

// const headtitle = "Landing page";
// const headsubTitle = "当社のサービス";
// const headsubdec = "サービス";

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>ITサービス一覧 | システム開発・コンサル・Odoo | グローバルジャパンネットワーク</title>
        <meta
          name="description"
          content="グローバルジャパンネットワークは、システム開発、Odoo導入、ITコンサル、エンジニアリングなど多様なサービスで企業のDXをサポートします。"
        />
        <meta property="og:title" content="ITサービス一覧 | システム開発・コンサル・Odoo | グローバルジャパンネットワーク" />
        <meta property="og:description" content="グローバルジャパンネットワークは、システム開発、Odoo導入、ITコンサル、エンジニアリングなど多様なサービスで企業のDXをサポートします。" />
        <meta property="og:url" content="https://gjnetwork.jp" />
        <meta property="og:image" content="https://gjnetwork.jp/img/global-japan-og-img.jpg" />
        <link rel="canonical" href={`https://gjnetwork.jp${window.location.pathname}`} />
      </Helmet>

      <Navbarlp />

      <HeroSection />
      <ChallengesSection />
      <FeaturesSection />
      <ComparisonTable />
      <SystemArchitecture />
      <ComponentsList />
      <CaseStudies />
      <UsageFlow />
      <TeamSection />
      <Pricing />
      <Faq />
      <ContactSection />

      <FooterLP />
    </>
  );
};

export default LandingPage;
